import { gql } from "@apollo/client";

export const updateDutyRequestStatusMutation = gql`
mutation UpdateDutyRequestStatus($requestId: String!, $status: String!, $rejectionReason: String) {
  updateDutyRequestStatus(requestId: $requestId, status: $status, rejectionReason: $rejectionReason) {
    message
    response
  }
}
`;
